var parameterInsert={ 
    IdDocType:'',
    ColumnName:'',
    ColumnType:'',  
    FieldName:'',
    FieldType:'',
    FieldLevel2:0,
    FieldLevel2ValueIsVisible:0,
    FieldIsAPP:0,
    TargetIdField:0,
    TargetValueIsVisible:0,
    IsValidated:1,
    Active:'1',
    User:'',
    IP:'',
    IdDocListSelect:0,
    IdExpressionRegulate:0,
    IdDocCategory:0
} 
var parameterUpdate={
    IdDocField:'',
    FieldName:'',
    FieldType:'', 
    FieldLevel2ValueIsVisible:0,
    FieldIsAPP:0,
    TargetIdField:0,
    TargetValueIsVisible:0,
    IsValidated:1,
    Active:'1',
    User:'',
    IP:'',
    IdDocListSelect:0,
    IdExpressionRegulate:0
} 
var parameterView={ 
    IdDocType:'0' 
} 
var parameterCategoryView={ 
    IdDocCategory:'0' 
} 
export default
{
    parameterInsert,
    parameterUpdate,
    parameterView
}